(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/react/shared-components/main-page.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/react/shared-components/main-page.js');

'use strict';

const {
  Grid,
  GridCol
} = svs.ui.ReactGrid;
const MainPage = _ref => {
  let {
    children
  } = _ref;
  return React.createElement(Grid, {
    className: "margin-xs-top-2"
  }, React.createElement(GridCol, {
    className: "padding-xs-1 padding-sm-0",
    xs: 12,
    sm: {
      col: 10,
      offset: 1
    },
    am: {
      col: 8,
      offset: 2
    },
    md: {
      col: 6,
      offset: 3
    },
    lg: {
      col: 6,
      offset: 3
    },
    xl: {
      col: 4,
      offset: 4
    }
  }, children));
};
svs.termsIntegrity.sharedComponents.MainPage = MainPage;

 })(window);